<div class="text-widget-navigation-n" [style.padding-bottom]="bottomGap">
  <div
    *ngIf="hasOptions"
    class="options-panel"
    [style.grid-template-columns]="buttonsGridTemplateColumns"
    [style.gap]="optionsGap"
    [style.max-width]="panelMaxWidth"
  >
    <section
      *ngFor="let option of navigationOptions; trackBy: trackByIndex"
      class="option-card"
      [style.background-color]="getOptionBackgroundColor(option)"
      [style.color]="getOptionTextColor(option)"
      [style.border-color]="getOptionBorderColor(option)"
      [style.border-width]="getOptionBorderWidth(option)"
      [style.border-radius]="getOptionBorderRadius(option)"
      [style.box-shadow]="getOptionBoxShadow(option)"
      [style.padding]="getOptionPadding(option)"
      [style.height]="getOptionHeight(option)"
      [style.min-height]="getOptionMinHeight(option)"
      [style.min-width]="getOptionMinWidth(option)"
      [style.width]="getOptionWidth(option)"
      [style.justify-self]="moduleJustify"
      [style.--nav-accent-color]="getTopBorderColor(option)"
      [style.--nav-divider-color]="getDividerColor(option)"
      [style.--nav-icon-bg-color]="getIconBackgroundColor(option)"
      [style.--nav-icon-color]="getIconColor(option)"
      [style.--nav-module-color]="getModuleLabelColor(option)"
      [style.--nav-title-color]="getTitleColor(option)"
      [style.--nav-subtitle-color]="getSubtitleColor(option)"
      [style.font-size]="getOptionFontSize(option)"
      [style.font-weight]="getOptionFontWeight(option)"
      [style.font-style]="getOptionFontStyle(option)"
      [style.font-family]="getOptionFontFamily(option)"
    >
      <span
        *ngIf="hasActionButtons(option); else legacyOptionCard"
        class="card-shell"
        [style.padding]="cardPadding"
        [style.--nav-top-border-height]="topBorderHeight"
        [style.--nav-header-gap]="headerGap"
        [style.--nav-icon-wrap-size]="getIconWrapSize()"
        [style.--nav-icon-size]="getIconSize()"
        [style.--nav-icon-radius]="getIconBorderRadius()"
        [style.--nav-module-font-size]="getModuleLabelFontSize()"
        [style.--nav-module-font-weight]="getModuleLabelFontWeight()"
        [style.--nav-title-font-size]="getTitleFontSize()"
        [style.--nav-title-font-weight]="getTitleFontWeight()"
        [style.--nav-subtitle-font-size]="getSubtitleFontSize()"
        [style.--nav-subtitle-font-weight]="getSubtitleFontWeight()"
      >
        <span class="card-header">
          <span class="card-top-icon-wrap" *ngIf="getOptionTopIcon(option)">
            <img *ngIf="isImageIcon(getOptionTopIcon(option)); else optionTopMatIcon" class="card-top-icon-image" [src]="getOptionTopIcon(option)" alt="" />
            <ng-template #optionTopMatIcon>
              <mat-icon class="card-top-icon">{{ getOptionTopIcon(option) }}</mat-icon>
            </ng-template>
          </span>

          <span class="card-heading">
            <span *ngIf="getOptionModuleLabel(option)" class="card-module-label">
              {{ getOptionModuleLabel(option) }}
            </span>

            <span class="card-title">
              {{ formatOptionLabel(option) }}
            </span>

            <span *ngIf="getOptionSubtitle(option)" class="card-subtitle">
              {{ getOptionSubtitle(option) }}
            </span>
          </span>
        </span>

        <span class="card-divider"></span>

        <span class="action-buttons" [style.gap]="actionButtonsGap">
          <button
            *ngFor="let button of getActionButtons(option); trackBy: trackByIndex"
            type="button"
            class="option-btn"
            [disabled]="option.disabled || button.disabled"
            [style.background-color]="getActionButtonBackgroundColor(button)"
            [style.color]="getActionButtonTextColor(button)"
            [style.border-radius]="getActionButtonBorderRadius(button)"
            [style.min-height]="getActionButtonMinHeight(button)"
            [style.font-size]="getActionButtonFontSize(button)"
            [style.font-weight]="getActionButtonFontWeight(button)"
            [style.padding]="getActionButtonPadding(button)"
            (click)="onOptionClick(option, button, $event)"
          >
            {{ formatButtonLabel(button) }}
          </button>
        </span>
      </span>
      <ng-template #legacyOptionCard>
        <button
          type="button"
          class="legacy-option-btn"
          [disabled]="option.disabled"
          (click)="onLegacyOptionClick(option, $event)"
        >
          <span class="legacy-card-shell">
            <span class="legacy-card-top-row">
              <span class="legacy-card-top-left">
                <span class="legacy-card-top-icon-wrap" *ngIf="getOptionTopIcon(option)">
                  <img *ngIf="isImageIcon(getOptionTopIcon(option)); else legacyTopMatIcon" class="legacy-card-top-icon-image" [src]="getOptionTopIcon(option)" alt="" />
                  <ng-template #legacyTopMatIcon>
                    <mat-icon class="legacy-card-top-icon">{{ getOptionTopIcon(option) }}</mat-icon>
                  </ng-template>
                </span>

                <span *ngIf="getOptionModuleLabel(option)" class="legacy-card-module-label">
                  {{ getOptionModuleLabel(option) }}
                </span>
              </span>
            </span>

            <span class="legacy-card-title">
              {{ formatOptionLabel(option) }}
            </span>

            <span *ngIf="getOptionSubtitle(option)" class="legacy-card-subtitle">
              {{ getOptionSubtitle(option) }}
            </span>

            <span class="legacy-card-divider"></span>

            <span class="legacy-card-bottom-icon-wrap" *ngIf="getOptionBottomIcon(option)">
              <img *ngIf="isImageIcon(getOptionBottomIcon(option)); else legacyBottomMatIcon" class="legacy-card-bottom-icon-image" [src]="getOptionBottomIcon(option)" alt="" />
              <ng-template #legacyBottomMatIcon>
                <mat-icon class="legacy-card-bottom-icon">{{ getOptionBottomIcon(option) }}</mat-icon>
              </ng-template>
            </span>
          </span>
        </button>
      </ng-template>
    </section>
  </div>
</div>
